module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('h1', {
    staticClass: "•-CH-NUM-8-4-2015",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("The Wright Stuff:")])]), _vm._v(" "), _c('h1', {
    staticClass: "•-CH-NUM-8-4-2015PMOD"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("From NBC to Autism Speaks")])]), _c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "•-CH-NUM-8-4-2015"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Bob Wright")])]), _vm._v(" "), _c('h1', {
    staticClass: "•-CH-NUM-8-4-2015PMOD"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("with Diane Mermigas")]), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1PMOD"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1PMOD",
    attrs: {
      "alt": "",
      "src": "image/_RosettaBooks_Logo.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "•-CH-TITLE-8-4-2015PMOD",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("New York, 2016")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c70132","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ebook_-_test.vue
// module id = 57
// module chunks = 0